<template>
  <div class="panel-wrapper">
    <section class="section">
      <h1>{{ $t('translatorPanel.welcome', { name: user?.name }) }}</h1>

      <!-- Sekmeler -->
      <div class="tabs">
        <button :class="{ active: tab === 'assigned' }" @click="tab = 'assigned'">
          {{ $t('translatorPanel.tabs.assigned') }}
        </button>
        <button :class="{ active: tab === 'open' }" @click="tab = 'open'">
          {{ $t('translatorPanel.tabs.open') }}
        </button>
        <button :class="{ active: tab === 'offered' }" @click="tab = 'offered'">
          {{ $t('translatorPanel.tabs.offered') }}
        </button>
        <button :class="{ active: tab === 'completed' }" @click="tab = 'completed'">
          {{ $t('translatorPanel.tabs.completed') }}
        </button>
      </div>

      <!-- İçerik -->
      <div class="tab-content">
        <TranslatorAssignedJobs v-if="tab === 'assigned'" />
        <TranslatorOpenJobs v-else-if="tab === 'open'" />
        <TranslatorMyOffers v-else-if="tab === 'offered'" :offers="myOffers" />
        <TranslatorCompletedJobs v-else-if="tab === 'completed'" />
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { getUser, getToken } from '@/utils/auth'
import TranslatorAssignedJobs from '@/pages/translator/TranslatorAssignedJobs.vue'
import TranslatorOpenJobs from '@/pages/translator/TranslatorOpenJobs.vue'
import TranslatorMyOffers from '@/pages/translator/TranslatorMyOffers.vue'
import TranslatorCompletedJobs from '@/pages/translator/TranslatorCompletedJobs.vue'

const baseURL = process.env.VUE_APP_API_URL
const user = getUser()
const tab = ref('assigned')

const myOffers = ref([])

async function fetchMyOffers() {
  try {
    const res = await fetch(`${baseURL}/translator/my-offers`, {
      headers: { Authorization: `Bearer ${getToken()}` }
    })
    if (!res.ok) throw new Error('Teklifler alınamadı.')
    const data = await res.json()
    myOffers.value = data
  } catch (error) {
    console.error('Teklif yükleme hatası:', error)
  }
}

onMounted(() => {
  fetchMyOffers()
})
</script>

<style scoped>
.panel-wrapper {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 100vh;
  padding-top: 100px;
  background-size: cover;
}
.section {
  padding: 30px;
  max-width: 1100px;
  margin: 0 auto;
  background: white;
  border-radius: 12px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
}
.section h1 {
  text-align: center;
  font-size: 24px;
  margin-bottom: 30px;
  color: #333;
  display: flex;
  justify-content: center;
  align-items: center;
}
.tabs {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-bottom: 30px;
}
.tabs button {
  padding: 10px 20px;
  border: none;
  background: #eee;
  border-radius: 25px;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.3s ease;
}
.tabs .active {
  background: #3498db;
  color: white;
}
.tab-content {
  margin-top: 20px;
  background: #fdfdfd;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.03);
}
@media (max-width: 768px) {
  .section {
    padding: 20px;
    margin: 0 10px;
  }

  .tabs {
    flex-direction: column;
    gap: 10px;
    align-items: stretch;
  }

  .tabs button {
    width: 100%;
    padding: 10px;
    font-size: 14px;
  }

  .section h1 {
    font-size: 20px;
    flex-wrap: wrap;
    text-align: center;
  }

  .tab-content {
    padding: 16px;
  }
}

</style>
